import { jsx as _jsx } from "react/jsx-runtime";
/*
 * Thunderstorm is a full web app framework!
 *
 * Typescript & Express backend infrastructure that natively runs on firebase function
 * Typescript & React frontend infrastructure
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { composeUrl } from '@nu-art/ts-common';
import { Link, NavLink, Route } from 'react-router';
export class RoutePath {
    key;
    path;
    exact = false;
    component;
    logMessage;
    label;
    visible = () => !!this.label;
    enabled;
    constructor(key, route, component) {
        this.key = key;
        this.path = route;
        this.component = component;
    }
    setLogMessage(logMessage) {
        // @ts-ignore
        this.logMessage = logMessage;
        return this;
    }
    setLabel(label) {
        // @ts-ignore
        this.label = label;
        return this;
    }
    setVisible(visible) {
        // @ts-ignore
        this.visible = visible;
        return this;
    }
    setEnabled(enabled) {
        // @ts-ignore
        this.enabled = enabled;
        return this;
    }
    setExact(exact) {
        // @ts-ignore
        this.exact = exact;
        return this;
    }
    compose(params) {
        return composeUrl(this.path, params);
    }
}
const getNavStyles = (props) => {
    return {
        color: props.isActive ? 'blue' : undefined,
    };
};
export const defaultNavLinkNode = (route) => {
    return _jsx(NavLink, { to: route.path, style: getNavStyles, children: route.label }, route.key);
};
export const defaultLinkNode = (route, node) => {
    return _jsx(Link, { to: route.path, children: node || route.label || route.key }, route.key);
};
export const defaultRouteNode = (route) => {
    // if (typeof route.component === 'string')
    // 	return <ReactEntryComponentInjector src={route.component}/>;
    const Component = route.component;
    return _jsx(Route, { path: route.path, element: _jsx(Component, {}) }, route.key);
};
//# sourceMappingURL=route.js.map